import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { CustomControlsModule } from '@identic/controls';
import { AuthGuard } from '@identic/auth';
import { CaseDataAccessModule } from 'case/data-access';
import { CaseEditorModule, CaseEditorComponent } from './editor';

export const routerModuleForChild = RouterModule.forChild([
  { path: '', component: CaseEditorComponent, canActivate: [AuthGuard] },
  { path: 'list', redirectTo: '', pathMatch: 'full' },
]);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    routerModuleForChild,
    CustomControlsModule.forRoot(),
    CaseDataAccessModule,
    CaseEditorModule,
  ],
})
export class CaseModule {}
